declare const __webpack_require__: unknown;

interface ImportMetaEnvShape {
	DEV?: boolean;
}

/**
 * Determine if the current runtime is executing a webpack bundle.
 *
 * @returns True when the webpack runtime is available.
 */
export function isWebpackRuntime(): boolean {
	return typeof __webpack_require__ === 'function';
}

/**
 * Determine if the current runtime is Vite development mode.
 *
 * @returns True when running in Vite dev and not in webpack runtime.
 */
export function isViteDevRuntime(): boolean {
	const viteEnv = (import.meta as unknown as {
		env?: ImportMetaEnvShape;
	}).env;

	return Boolean(viteEnv?.DEV) && !isWebpackRuntime();
}
